import React, { useState, useEffect } from 'react';
import {useTheme, makeStyles, IconButton, Typography, Box} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  containerIn: {
    position: 'fixed',
    zIndex: 1300,
    inset: 0,
    transition: 'all .3s ease',
  },
  containerLeftOut: {
    position: 'fixed',
    zIndex: 1300,
    inset: 0,
    transform: 'translateX(-100%)',
    visibility: 'hidden',
    transition: 'all .3s ease',
  },
  containerRightOut: {
    position: 'fixed',
    zIndex: 1300,
    inset: 0,
    transform: 'translateX(100%)',
    visibility: 'hidden',
    transition: 'all .3s ease',
  },
  clickAway: {
    zIndex: -1,
    position: 'fixed',
    inset: 0,
    backgroundColor: 'transparent'
  },
  panelLeftOut: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    maxWidth: 600,
    zIndex: 999,
    backgroundColor: '#fff',
    overflowY: 'auto',
    overflowX: 'hidden',
    transform: 'translateX(-100%)',
    visibility: 'hidden',
    left: 0,
    top: 0,
    transition: 'all .3s ease',
    flexDirection: 'column',
    alignItems: 'center',
  },
  panelLeftIn: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    maxWidth: 600,
    zIndex: 999,
    backgroundColor: '#fff',
    overflowY: 'auto',
    overflowX: 'hidden',
    transform: 'translateX(0)',
    left: 0,
    top: 0,
    transition: 'all .3s ease',
    flexDirection: 'column',
    alignItems: 'center',
  },
  panelRightOut: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    maxWidth: 600,
    zIndex: 999,
    backgroundColor: '#fff',
    overflowY: 'auto',
    overflowX: 'hidden',
    transform: 'translateX(100%)',
    visibility: 'hidden',
    right: 0,
    top: 0,
    transition: 'all .3s ease',
    flexDirection: 'column',
    alignItems: 'center',
  },
  panelRightIn: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    maxWidth: 600,
    zIndex: 999,
    backgroundColor: '#fff',
    overflowY: 'auto',
    overflowX: 'hidden',
    transform: 'translateX(0)',
    right: 0,
    top: 0,
    transition: 'all .3s ease',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inner: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '86%',
    paddingTop: 40
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 20
  }
}));


const SideSlidePanel = props => {

  const theme = useTheme();
  const classes = useStyles(theme);

  const side = typeof props.side !== 'undefined' ? props.side : 'LEFT';

  const [ show, setShow ] = useState(false)
  const [ render, setRender ] = useState(false);

  useEffect(() => {
    setShow(props.show);
    setRender(props.show);
  }, [props.show])

  const handleAnimationEnd = () => {
    if(show === false){
      setRender(false);
      if(typeof props.handleClose === 'function')
        props.handleClose();
    }
  }

  const handleClose = () => {
    setShow(false);
  }

  return (
    <div className={show ? classes.containerIn : (side.toUpperCase() === 'RIGHT' ? classes.containerRightOut : classes.containerLeftOut)}>
      <div className={classes.clickAway} onClick={handleClose}></div>
      {render && <Box 
        className={show ? (side.toUpperCase() === 'RIGHT' ? classes.panelRightIn : classes.panelLeftIn) : (side.toUpperCase() === 'RIGHT' ? classes.panelRightOut : classes.panelLeftOut)} 
        boxShadow={3}
        onTransitionEnd={handleAnimationEnd}
      >
          <IconButton onClick={handleClose} className={classes.close}><CloseIcon /></IconButton>
          <div className={classes.inner}>
            <Typography variant='h4' color="primary">{props.title}</Typography>
            {props.children}
          </div>
      </Box>}
    </div>
  );
}

export default SideSlidePanel;
